(() => {
  if (window.__eleatProductionEnhancementsInitialised) return;
  window.__eleatProductionEnhancementsInitialised = true;
  const galleries = new Map();
  const enableSticky = () => {
    if (document.body && document.body.getAttribute('data-ab-test-header-sticky') !== 'true') document.body.setAttribute('data-ab-test-header-sticky', 'true');
  };
  enableSticky();
  const initialise = scope => {
    enableSticky();
    const containers = Array.from(scope.querySelectorAll('.product-template-images__desktop'));
    if (scope.matches?.('.product-template-images__desktop')) containers.unshift(scope);
    containers.forEach(container => {
      if (galleries.has(container)) return;
      const first = container.querySelector('.images__button');
      if (first && !container.querySelector('.images__button.active-thumbnail')) first.classList.add('active-thumbnail');
      const onClick = event => {
        const button = event.target.closest?.('.images__button');
        if (!button || !container.contains(button)) return;
        container.querySelectorAll('.images__button.active-thumbnail').forEach(active => {
          if (active !== button) active.classList.remove('active-thumbnail');
        });
        if (!button.classList.contains('active-thumbnail')) button.classList.add('active-thumbnail');
      };
      container.addEventListener('click', onClick);
      galleries.set(container, onClick);
    });
    const button = document.querySelector('.nutritional-info-button');
    const accordions = document.querySelector('.build-a-bundle__accordions');
    if (button && accordions && accordions.firstElementChild !== button) accordions.prepend(button);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise(document), {once: true});
  else initialise(document);
  document.addEventListener('shopify:section:load', event => initialise(event.target));
  document.addEventListener('shopify:section:unload', event => {
    galleries.forEach((onClick, container) => {
      if (!event.target.contains(container)) return;
      container.removeEventListener('click', onClick);
      galleries.delete(container);
    });
  });
})();
